module.exports = __webpack_public_path__ + "static/media/covid.1fbb790d.png";